export default __webpack_public_path__ + "static/media/H_Underlay.f8a4eb6d.jpg";